import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { ToastrManager } from 'ng6-toastr-notifications';
import { PayService } from 'src/app/models/pay-service';
import { UnitType } from 'src/app/models/unit-type';
import { ReportService } from 'src/app/services/report.service';
import { ServiceService } from 'src/app/services/service.service';
import { downloadFile } from 'src/app/src/utl';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-unities-services-report',
  templateUrl: './unities-services-report.component.html',
  styleUrls: ['./unities-services-report.component.css'],
  providers: [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }]
})
export class UnitiesServicesReportComponent implements OnInit {

  loading:boolean = false;
  expand:boolean = false;

  today = new Date();
  date1 = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
  date2 = new Date();

  unit_types:UnitType [] = [];
  unit_type:UnitType = new UnitType();

  pay_services_all:PayService[] = [];
  pay_services_temp:PayService[] = [];
  totalService:number = 0;
  totalExtra:number = 0;

  constructor(private reportServ:ReportService, private serviceServ:ServiceService, private toastr:ToastrManager) { }

  ngOnInit() {
    this.search();
  }
  
  search(){
    this.loading = true;
    this.totalService = 0;
    this.totalExtra = 0;
    this.reportServ.getPayServiceReport(this.date1, this.date2).subscribe(pay_services => {
      this.pay_services_all = pay_services;
      this.pay_services_temp = pay_services;
      this.unit_types = [];
      this.pay_services_all.map(pay =>{
        this.totalService += Number(pay.price + pay.iva);
        this.totalExtra += Number(pay.extra_cost);
        if(this.unit_types.findIndex(uni => uni.name === pay.unity.unit_type.name) === -1){ this.unit_types.push(pay.unity.unit_type); }
      });
      this.loading = false;
    },error => {
      this.toastr.errorToastr("No se pudieron recuperar los registros de los pagos de servicios de las unidades.");
      this.loading = false;
    });
  }

  selectUnitType(name){
    this.pay_services_temp = (name)?this.pay_services_all.filter(pay => pay.unity.unit_type.name == name):this.pay_services_all;
    this.totalService = 0;
    this.totalExtra = 0;
    this.pay_services_temp.map(pay =>{
      this.totalService += Number(pay.price + pay.iva);
      this.totalExtra += Number(pay.extra_cost);
    });
  }

  download(type){
    window.open(environment.baseUrl + '/' + type + '/unit-services?date1='+this.date1+'&date2='+this.date2+'&type='+((this.unit_type.name.length > 0)?this.unit_type.name:'all'), '_blank');
  }

  downloadFilePayService(id, filename){
    this.loading = true;
    this.serviceServ.downloadFilePayService(id, filename).subscribe(resp => {
      downloadFile(resp, filename);
      this.loading = false;
    },error => {
      this.loading = false;
    });
  }

}
